export const RESERVED_CONTENT_FOR_ARGUMENTS = [
  'attributes',
  'block',
  'blocks',
  'class',
  'context',
  'inherit',
  'resource',
  'resources',
  'schema',
  'section',
  'sections',
  'settings',
  'snippet',
  'snippets',
  'src',
  'style',
  'styles',
  'template',
  'templates',
];

export const REQUIRED_CONTENT_FOR_ARGUMENTS = ['id', 'type'];

export const CLOSEST_ARGUMENT = 'closest.';
